import Simple from "../../../Components/InputFields/Simple";
import GradientBlue from "../../../Components/InputFields/GradientBlue";
import Divider from "./Divider";
import SimpleButton from "../../../Components/Buttons/Simple";
import LogoWhite10 from "../../../Media/PNG/LogoWhite10.svg";
import LogoBlue from "../../../Media/PNG/LogoBlue.svg";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getNextFromRedirect,
  getRedirectFromNext,
} from "../../../helper/nextRedirect";
import NavLayer2 from "../../../Components/NavLayer2/NavLayer2";
import BackToHome from "./BackToHome";
import { API_BASE_URL } from "../../../config/api";

export default function ContainerSignInPhone({ text }) {
  const isDark =
    typeof document !== "undefined" &&
    document.documentElement.classList.contains("dark");
  const logoSrc = isDark ? LogoWhite10 : LogoBlue;
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { search } = useLocation();
  const nextParam = new URLSearchParams(search).get("next");
  const redirectFromNext = getRedirectFromNext(nextParam);
  const storedRedirect = localStorage.getItem("post_login_redirect");
  const redirectPath = redirectFromNext || storedRedirect;
  const nextForRedirect = nextParam || getNextFromRedirect(redirectPath);
  const hasRedirect = Boolean(redirectPath);
  const signupHref = nextForRedirect
    ? `/SignUp?next=${nextForRedirect}`
    : "/SignUp";
  const [signinData, setSigninData] = useState({
    email: "",
    password: "",
  });
  const [fieldsRequired, setFieldsRequired] = useState(false);
  const [invalidData, setInvalidData] = useState(false);

  useEffect(() => {
    if (redirectFromNext) {
      localStorage.setItem("post_login_redirect", redirectFromNext);
    }
  }, [redirectFromNext]);

  const handleEmailChange = (e) => {
    setSigninData({ ...signinData, email: e.target.value });
    setFieldsRequired(false);
    setInvalidData(false);
  };
  const handleSignin = async (e) => {
    e.preventDefault();
    // Handle sign-in logic here
    if (signinData.email === "" || signinData.password === "") {
      setFieldsRequired(true);
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(
        `${API_BASE_URL}auth/trader/login/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: signinData.email,
            username: signinData.email,
            password: signinData.password,
          }),
        },
      );

      const result = await response.json();

      if (!result.auth) {
        setLoading(false);
        setInvalidData(true);
        return;
      }

      // Check if server responded with error status
      if (!response.ok) {
        throw new Error(`https error! Status: ${response.status}`);
      }
      if (result.auth && result.twoFa) {
        // window.location.href = "/dashboard";
        localStorage.setItem(
          "authCredentials",
          JSON.stringify({
            email: signinData.email,
            password: signinData.password,
          }),
        );
        setLoading(false);
        if (hasRedirect) {
          localStorage.setItem("post_login_redirect", redirectPath);
        }
        const verificationPath = nextForRedirect
          ? `/verification-google?next=${nextForRedirect}`
          : "/verification-google";
        navigate(verificationPath);
      } else if (result.auth && !result.twoFa) {
        localStorage.setItem("refresh", result.refresh);
        localStorage.setItem("access", result.access);
        localStorage.setItem("role", result.role);
        localStorage.setItem("email", result.email);
        setLoading(false);
        if (hasRedirect) {
          localStorage.removeItem("post_login_redirect");
        }
        navigate(redirectPath || "/dashboard");
      }
    } catch (error) {
      setLoading(false);
      console.error("POST request failed:", error);
      return null; // or throw error again if you want
    }
  };

  return (
    <div className="w-full max-w-sm bg-zi-bg2-light dark:bg-zi-inputbg-dark/50 rounded-3xl p-5 gap-7 flex flex-col">
      <div className="flex flex-col gap-2 justify-center items-center">
        <div className="h-14">
          <img src={logoSrc} alt="لوگو" className="w-14" />
        </div>
        <p className="font-medium text-sm text-zi-text-light dark:text-zi-text-dark">
          کوژیتو فاند
        </p>
      </div>
      <NavLayer2
        texts={["ورود با ایمیل", "ورود با شماره همراه"]}
        hrefs={["/signin/email", "/signin/phone"]}
        activeIndex={1}
      />
      <div className="flex items-center justify-between gap-3">
        <h1 className="text-lg font-medium text-zi-text-light dark:text-zi-text-dark">
          {text}
        </h1>
        <BackToHome />
      </div>
      <div>
        <form className="flex flex-col gap-5">
          <Simple
            placeholder="شماره تلفن همراه"
            type="tel"
            id="phoneNumber"
            isNumeric={true}
            formValue={signinData.email}
            formOnChange={handleEmailChange}
          />
          {!loading ? (
            <GradientBlue
              type="submit"
              value="دریافت کد یک‌بار مصرف"
              onClick={handleSignin}
            />
          ) : (
            <GradientBlue
              isLoader={true}
              type="submit"
              value="دریافت کد یک‌بار مصرف"
              onClick={handleSignin}
            />
          )}
        </form>
        {fieldsRequired && (
          <p className="text-amber-400 text-sm font-extralight mt-1">
            لطفا تمامی فیلدها را پر کنید
          </p>
        )}
        {invalidData && (
          <p className="text-amber-400 text-sm font-extralight mt-1">
            شماره تلفن همراه وارد شده معتبر نیست
          </p>
        )}
        {/* <Divider text="یا" />
        <SimpleButton text="ورود با گوگل" svg_name="google"></SimpleButton> */}
        <Divider text="حساب کاربری ندارید؟" />
        <SimpleButton
          text="ثبت‌نام"
          svg_name=""
          href={signupHref}
        ></SimpleButton>
      </div>
    </div>
  );
}
